import { useState, useEffect } from 'react';

const breakpoints = {
  mobile: 768,
  tablet: 1024,
  laptop: 1440,
};

export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState({
    isMobile: false,
    isTablet: false,
    isLaptop: false,
    isWide: false,
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setBreakpoint({
        isMobile: width < breakpoints.mobile,
        isTablet: width >= breakpoints.mobile && width < breakpoints.tablet,
        isLaptop: width >= breakpoints.tablet && width < breakpoints.laptop,
        isWide: width >= breakpoints.laptop,
        width,
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoint;
};
